import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]

import { FormEvents } from "@/enums/form-events.enum";
import { useAnalyticsStore } from "@/store";
import { RichText } from "@sitecore-jss/sitecore-jss-vue";
import { computed } from "vue";

export interface BannerProps {
    content?: string;
    ctaLabel?: string;
    ctaLink?: string;
    collapsed?: boolean;
    testId?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Banner',
  props: {
    content: {},
    ctaLabel: {},
    ctaLink: {},
    collapsed: { type: Boolean },
    testId: {}
  },
  setup(__props: any) {

const { pushClickEvent } = useAnalyticsStore();


const props = __props;

const hasCTA = computed(() => {
    return ctaLabel.value && ctaLabel.value.trim().length > 0;
});

const ctaLabel = computed(() => {
    return props.ctaLabel;
});

const ctaLink = computed(() => {
    return props.ctaLink;
});

const content = computed(() => {
    return props.content;
});

const hasContent = computed(() => {
    return content.value && content.value.trim().length > 0;
});

const testId = computed(() => {
    return props.testId;
});

const cssClass = computed(() => `rounded-md m-4 mb-0 px-4 py-3 bg-racq-info-blue text-sm${props.collapsed === true ? " hidden" : ""}`); 

const onCTAClick = () => {
    pushClickEvent({ 
        event: FormEvents.INTERACTION_LINK_CLICK, 
        eventInfo: { 
            navigation: { 
                id: `link_${props.testId}_cta`,
                url: props.ctaLink || "",
                name: props.ctaLabel || "",
                type: "Link",
                linkClicks: 1,
            }
        }
    });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-testid": testId.value,
    class: _normalizeClass(cssClass.value)
  }, [
    (hasContent.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_unref(RichText), {
            field: {value: content.value},
            tag: "span"
          }, null, 8, ["field"])
        ]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode("  ")),
    (hasCTA.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: ctaLink.value,
          onClick: onCTAClick,
          class: "text-base-link text-racq-blue underline font-medium"
        }, _toDisplayString(ctaLabel.value), 9, _hoisted_3))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})